import { StyleSheet } from 'react-native';

import { lightGrey } from 'utils/colors';
import { widthPercentageToDP } from 'utils/responsiveness';

const styles = StyleSheet.create({
    root: {
        width: '100%',
        paddingBottom: 12,
        borderBottomWidth: 1,
        borderBottomColor: lightGrey(0.1),
        marginTop: 25,
        marginBottom: 20,
    },
    title: {
        marginLeft: widthPercentageToDP(72),
        marginRight: 'auto',
    },
    button: {
        marginRight: widthPercentageToDP(72),
    },
});

export default styles;
